import './App.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';

import CalendarSummary from './pages/CalendarSummary';
import FullCalendar from './pages/FullCalendar';

function App() {

  return (
      <Router>
        {/* <Calendar apiKey={API_KEY} calendars={calendars} showFooter={false}/> */}
          <Routes>
              <Route path="/calendar-summary"  element={<CalendarSummary/>} />
              <Route path="/" element={<FullCalendar/>} />
          </Routes>
      </Router>
  );
}

export default App;
